import { Component, Input, OnInit } from '@angular/core';

import { HomrGTGTContent } from '@shared/data-access/interfaces';

@Component({
    selector: 'pdp-gtgt-content',
    templateUrl: './gtgt-content.component.html',
    styleUrls: ['./gtgt-content.component.scss'],
    standalone: false
})
export class GtgtContentComponent implements OnInit {
	@Input()
	public gtgtContent: HomrGTGTContent;

	/**
	 * @description
	 * Text color
	 */
	public textColor = '#910208';

	ngOnInit(): void {
		// Check to see if a color is provided by homR
		if (typeof this.gtgtContent?.foregroundColor === 'string' && this.gtgtContent.foregroundColor.trim() !== '') {
			// Use the homR color
			this.textColor = this.gtgtContent.foregroundColor;
		}
	}

	public displayLink() {
		return this.gtgtContent !== undefined ? this.gtgtContent.linkTitle?.length > 0 && this.gtgtContent.link?.length > 0 : false;
	}
}
